import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClosedPlanView, ClosedPlanViewDefaultValues } from 'src/app/components/participants/plans/plan';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { PlanService } from 'src/app/services/plan.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-view-close-plan',
    templateUrl: './view-close-plan.component.html',
    styleUrls: ['./view-close-plan.component.scss'],
    standalone: false
})
export class ViewClosePlanComponent {
  closedPlanView: ClosedPlanView = ClosedPlanViewDefaultValues();
  participantClassByRole: string = '';
  translations: any;
  llttfPage: boolean = false;

  constructor(private _planservice: PlanService,
    private route: ActivatedRoute,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.closedPlanView.id = params['planid'];
      this._planservice.viewPlan(this.closedPlanView.id).subscribe({
        next: (data) => {
          this.closedPlanView = data;
        }
      });
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;

    this.translationservice.getTranslation().subscribe({
      next:(value)=> {
        this.translations = value
      },
    });
  }

  getScheduleLabel(value: string | undefined): string {
    if (!value || !this.translations) {
      return value || '';
    }
    const scheduleMap: Record<string, string> = {
      'Today': 'scheduleTodayText',
      'Tomorrow': 'scheduleTomorrowText',
      'Daily': 'scheduleDailyText',
      'Weekly': 'scheduleWeeklyText',
      'Monthly': 'scheduleMonthlyText',
      'Specify Date': 'scheduleSpecifyDateText',
    };
    for (const [english, key] of Object.entries(scheduleMap)) {
      if (value === english || value.startsWith(english + ' ')) {
        const translated = this.translations[key] || english;
        return value.replace(english, translated);
      }
    }
    return value;
  }

}
